var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: this.$t("admin.telemetry") } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: this.$t("admin.preferences"),
                "label-size": "lg",
                "label-class": "font-weight-bold pt-0 mb-2",
              },
            },
            [
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: {
                      id: "submission-enabled",
                      color: "primary",
                      label: "",
                    },
                    model: {
                      value: _vm.isSubmissionEnabled,
                      callback: function ($$v) {
                        _vm.isSubmissionEnabled = $$v
                      },
                      expression: "isSubmissionEnabled",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(
                _vm._s(this.$t("admin.enable_telemetry_submission")) + "\n    "
              ),
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                "label-size": "lg",
                "label-class": "font-weight-bold pt-0 mb-2",
                label: this.$t("admin.telemetry_last_submission"),
                description: _vm.lastSubmissionDataDescription,
                "label-for": "last-submission-data",
              },
            },
            [
              _c("b-form-textarea", {
                attrs: {
                  id: "last-submission-data",
                  value: _vm.lastSubmissionDataString,
                  rows: "3",
                  "max-rows": "6",
                  readonly: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { size: "md", variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }